export default __webpack_public_path__ + "static/media/fioretto-with-cheese-sauce.c6c5de5e.png";